export const PROFILES = {
  SALES: 'Comercial',
  DIRECTOR: 'Diretoria',
  FINANCIAL: 'Financeiro',
  MARKETING: 'Marketing',
  TECHNICAL: 'Técnico',
} as const;

export type ProfileType = keyof typeof PROFILES;

export default PROFILES; 
